export const avg = (arr) => arr.length === 0 ? 0 : arr.reduce((sum, currValue) => sum + +currValue, 0) / arr.length;
export const round = (num, dot = 0) => Math.round(+num * Math.pow(10, dot)) / Math.pow(10, dot);

export const convertArrayToString = (arr, key) => {
    return arr.reduce((acc, cur) => {
        if (typeof cur === 'object' && cur.hasOwnProperty(key)) {
            const value = cur[key];
            return acc + (acc ? ',' : '') + `'${value}'`;
        } else if ("USER_ID" === key) {
            const value = cur["WORKER_ID"];
            return acc + (acc ? ',' : '') + `'${value}'`;
        } else {
            return acc + (acc ? ',' : '') + `'${cur}'`;
        }
    }, '');
};

export const getMonthDiff = (start,end) => {
    const monthDiff = dayjs(end).diff(dayjs(start), 'month');
    if(monthDiff > 0 && monthDiff <= 3) return monthDiff;
    return 0; // 0 은 사용자 지정
}
export const covertStringToArray = (str) => str.split(',').map(str => str.replace(/'/g, ''));

export const isObjectEmpty = (obj) =>  Object.keys(obj).length === 0;

export const convertMinutes = (minutes) => {
    const units = [
        { name: "년", value: 365 * 24 * 60 },
        { name: "개월", value: 30 * 24 * 60 },
        { name: "일", value: 24 * 60 },
        { name: "시간", value: 60 },
        { name: "분", value: 1 },
    ];
    return units.reduce((acc, unit) => {
        const amount = Math.floor(minutes / unit.value);
        minutes %= unit.value;
        return amount > 0 ? acc + amount + unit.name + ' ' : acc;
    }, '').trim();
}
export const minutesToDays = (minutes) => {
    const hours = minutes / 60;
    const days = hours / 24;
    return Math.floor(days);
}
export const minutesToMonth = (minutes) => {
    const months = minutesToDays(minutes) / 30.4375;
    return Math.floor(months);
}

export const getYaxisByMinutes = (maxMinutes) => (value) => {
    if(60*24 >= maxMinutes){
        return `${value}분`;
    }
    if(60*24*30 >= maxMinutes){
        return `${minutesToDays(value)}시간`;
    }
    if(60*24*30*12 >= maxMinutes){
        return `${minutesToDays(value)}일`;
    }
    return `${minutesToMonth(value)}개월`;
}
